import { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface Head8Props {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters' | 'none';
  overflow?: 'hidden' | 'visible';
}

const Head8 = ({
  children,
  maxLines = 2,
  className = '',
  isClamp = false,
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  ...props
}: Head8Props & React.ComponentProps<'p'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );
  return (
    <p
      style={{ ...lineClampStyle, ...style }}
      className={`text-[18px] leading-6 text-black90 ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

export default Head8;
